import debounce from 'lodash/debounce';
import { useCallback, useEffect, useState } from 'react';

export const useDebouncedSearchValue = (searchValue: string, delay = 300) => {
  const [debouncedSearchValue, setDebouncedSearchValue] = useState<string>('');

  const debouncedSetSearchValue = useCallback(
    debounce(setDebouncedSearchValue, delay),
    [delay],
  );

  useEffect(() => {
    debouncedSetSearchValue(searchValue);
  }, [searchValue, debouncedSetSearchValue]);

  return debouncedSearchValue;
};
